/* DYGAMING: event listeners on bet group tabs to filter matches list */

(function() {
  
  function updateTabsAndMatches(event) {
    var element = event.target;
    var time = element.getAttribute('data-time');
    var tabs = document.querySelectorAll('.bet-group-tab');
    tabs.forEach(function(tab) {
      tab.classList.remove('active');
      document.querySelectorAll('.list-view-item[data-time]').forEach(function(listViewItem) {
        listViewItem.classList.remove('active');
        if (listViewItem.getAttribute('data-time').includes(time)) {
          listViewItem.classList.add('active');
        }
      });
    });
    element.classList.add('active');
    
    if (document.querySelectorAll('.list-view-item[data-time].active').length == 0) {
      document.querySelector('.list--inline.pagination').classList.add('hidden');
    }
    else {
      document.querySelector('.list--inline.pagination').classList.remove('hidden'); 
    }
  }
  
  document.querySelectorAll('.bet-group-tab').forEach(function(betTab) {
    betTab.addEventListener('click', updateTabsAndMatches);
  });
  updateTabsAndMatches({target: document.querySelectorAll('.bet-group-tab')[0]});
  
})();


/* <!-- DYGAMING: create our own add-to-cart events since default Shopify implementation will be incorrect --> */
(function() {
  function fireDyCartEventFromCartJs(event) {
    var target = event.target;
	
    if (CartJS.cart.item_count > 0) {
      var sku = target.getAttribute('data-variant-sku');
      var totalPrice = CartJS.cart.total_price;
      var _dy_order_cart = [];
      var cartJsCart = CartJS.cart.items;
      for (var _index = 0; _index < cartJsCart.length; _index ++) {
        _dy_order_cart.push({
          productId: cartJsCart[_index].sku,
          quantity: cartJsCart[_index].quantity,
          itemPrice: parseFloat(cartJsCart[_index].final_line_price),
        });
      }

      setTimeout(function() {
        DY.API('event' , {
          name:'Add to Cart',
          properties: {
            dyType : 'add-to-cart-v1',
            value: parseFloat(totalPrice),
            currency: 'USD',
            quantity: 1,
            productId: sku,
            cart: _dy_order_cart
          }
        });
      }, 200);
    } 
  }

  const buttons = document.querySelectorAll(".list-bet-button button")
  for (const button of buttons) {
    button.addEventListener('click', fireDyCartEventFromCartJs);
  }
})();